<svg id="privateWhiteboard"></svg>
